import { Component, OnInit, Host, Injector, effect } from '@angular/core';
import { MenuItem, MenuService } from '../services/menu.service';
import { resolveMenuIcon } from '../services/menu-icons';
import { ToolbarDirective } from '../../utils/directives/styles/toolbar.directive';
import { ModuleVersionService } from '../../app/services/module-version.service';
import { VAZHIPADU_MODULE } from '../../app/services/module-version-menu';
import { VenueModuleService } from '../../app/services/venue-module.service';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    providers: [ToolbarDirective, MenuService],
    standalone: false
})
export class MobileMenuComponent implements OnInit {
  constructor(public menuService: MenuService,
    @Host() private toolbar: ToolbarDirective,
    private moduleVersionService: ModuleVersionService,
    private venueModuleService: VenueModuleService,
    private injector: Injector) {

  }

  ngOnInit() {

    this.menuService.setMenuITEMS();
    // Same live rebuild as NavMenuComponent (Workstream E phase 2).
    effect(() => {
      this.moduleVersionService.version(VAZHIPADU_MODULE)();
      this.menuService.setMenuITEMS();
    }, { injector: this.injector });
    // WS-FHP venue switch (D-FHP-9), same live rebuild.
    this.venueModuleService.ensureLoaded().subscribe();
    effect(() => {
      this.venueModuleService.venueModule();
      this.menuService.setMenuITEMS();
    }, { injector: this.injector });
  }
  reDirect() {
    this.toolbar.closeAll();
  }

  /** Relevant FA4 icon (no `fa-` prefix) for a mobile menu / sub-menu item. */
  iconFor(item: MenuItem): string {
    return resolveMenuIcon(item);
  }
}
